import "./ScheduleFilter.css";
import { useContext, useEffect, useState } from "react";
import ScheduleFilter from "./ScheduleFilter";
import { selectInterface } from "utilFunctions/shared/PerformanceSearchBar";
import {
  addDays,
  format,
  setHours,
  setMinutes,
  setSeconds,
  subDays,
} from "date-fns";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { ScheduleStatus } from "utilFunctions/shared/ScheduleStatus";
import InfoIcon from "Assets/Icons/InfoIcon";
import { Tooltip } from "reactstrap";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import { UserInfoContext } from "Context/CommonContext";
import AutoSearchInput from "utilFunctions/shared/AutoSearchInput";
import { BASE_URL, GLOBAL_SEARCH } from "utilFunctions/Constants/urlConstants";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
export interface IScheduleFilterInterface {
  subject?: number[] | null;
  startDate?: string | null;
  endDate?: string | null;
}

interface IScheduleFilter {
  startDate?: any;
  endDate?: any | null;
  subjects: selectInterface[];
  classes?: selectInterface[];
  handleFilter: (...args: any) => any;
  setIsTableFilterApplied?: any;
  isTableFilterApplied?: boolean;
  isNotmarkedVisible?: any;
  setIsNotmarkedVisible?: any;
  room?: any;
  syllabusStatus?: any;
  userInfo?: any;
  filterState?: any;
  setFilterState?: any;
  open?: any;
  setOpen?: any;
  setSelectedDateRange?: any;
  isPaneOpen?: boolean;
  setisPaneOpen?: any;
  setSearchedFaculty?: any;
  dateRanges?: any;
  setDateRanges?: any;
  totalUnmarkedLecture?: any;
  handleSearchFaculty?: any;
}

const ScheduleTableFilter = ({
  subjects,
  startDate,
  endDate,
  classes,
  room,
  syllabusStatus,
  handleFilter,
  handleSearchFaculty,
  isNotmarkedVisible,
  setIsNotmarkedVisible,
  filterState,
  setFilterState,
  open,
  setOpen,
  setSelectedDateRange,
  isPaneOpen,
  setisPaneOpen,
  dateRanges,
  setDateRanges,
  totalUnmarkedLecture,
}: IScheduleFilter) => {
  const { screen }: any = useWindowSize();
  const [isChecked, setIsChecked] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);
  const minimumAllowedEndDateISOString: string = format(
    subDays(new Date(), 15),
    "yyyy-mm-dd"
  );
  const maximumAllowedEndDateISOString: string = format(
    addDays(new Date(), 365),
    "yyyy-mm-dd"
  );
  const [min, setMin] = useState<string>(minimumAllowedEndDateISOString);
  const [max, setMax] = useState<string>(maximumAllowedEndDateISOString);
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const [inputValue, setInputValue] = useState<any>();
  const [offset, setOffSet] = useState<number>(0);
  const [suggestions, setSuggestions] = useState<any>([]);
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [searchURL, setSearchURL] = useState<string>("");
  const [hasMore, setHasMore] = useState<boolean>(false);
  const [searchName, setSearchName] = useState<any>();
  const [input, setInput] = useState("");
  const [selectedFaculty, setSelectedFaculty] = useState<any>(null);
  const limit = 10;
  useEffect(() => {
    if (localStorage.getItem("scheduledFilter")) {
      const parsedFilter = JSON.parse(
        localStorage.getItem("scheduledFilter") as any
      );
      if (parsedFilter) {
        setSearchName(parsedFilter.email);
        setInput(parsedFilter.email);
        setSelectedFaculty(parsedFilter.email);
      }
    }
  }, [localStorage.getItem("scheduledFilter")]);
  const NotMarkedChangeHandler = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const notMarked = event.target.checked;
    setIsNotmarkedVisible(notMarked);
  };
  const { makeRequest: GetSearchData, responseData: searchData } = useGetApi(
    (data: any) => {
      onFetcheddata(data);
    },
    (error: any) => {
      onFetchError(error);
    }
  );
  useEffect(() => {
    if (searchData && searchData != null) {
      if (offset == 0) {
        setSuggestions([...searchData["data"]]);
      } else {
        setSuggestions((previous: any) => [...previous, ...searchData["data"]]);
      }
      setHasMore(
        searchData["data"] && searchData["data"].length > 0 ? true : false
      );
    }
  }, [searchData]);
  const onFetchError = (error: any) => {
    console.log("erorr", error);
    setIsLoader(false);
    if (offset == 0) {
      // setSuggestions([]);
    } else {
      setOffSet(0);
    }
    setHasMore(false);
  };

  const onFetcheddata = (data: any) => {
    setIsLoader(false);
    console.log(data);
  };
  const searchDataHandler = (searchterm: any, value?: any, keyName?: any) => {
    console.log("key value", keyName, value, inputValue);
    let url = `${BASE_URL + GLOBAL_SEARCH}`;
    url = url + `?name=${searchterm}`;
    url =
      url +
      "&moduleType=" +
      "faculty" +
      "&fexRole=Faculty,Academic Head,Regional Head";
    setSearchURL(url);
    const newUrl = url + "&limit=" + limit + "&offset=" + offset;
    GetSearchData(newUrl);
  };
  const handleSetInputValue = (val: string) => {
    setInputValue(val);
    setOffSet(0);
  };
  const nextHandler = () => {
    const newOffset = offset + limit;
    setOffSet((previous) => previous + limit);
    const url = searchURL + "&limit=" + limit + "&offset=" + newOffset;
    GetSearchData(url);
  };
  const onClickHandler = (newSuggest: any) => {
    console.log(newSuggest, "newSuggest");
    setFilterState();
    setDateRanges([
      {
        startDate: new Date(
          format(
            setSeconds(setMinutes(setHours(subDays(new Date(), 3), 18), 30), 0),
            "yyyy-MM-dd HH:mm:ss"
          )
        ),
        endDate: new Date(
          format(
            setSeconds(setMinutes(setHours(addDays(new Date(), 3), 18), 29), 0),
            "yyyy-MM-dd HH:mm:ss"
          )
        ),
        key: "selection",
      },
    ]);
    localStorage.setItem("scheduledFilter", JSON.stringify(newSuggest));
    handleSearchFaculty(newSuggest);
    setSelectedFaculty(newSuggest);
  };
  const handleResetSearchfaculty = () => {
    localStorage.setItem("scheduledFilter", "");
    handleSearchFaculty(null);
    setSelectedFaculty(null);
    setInput("");
  };

  return (
    <div className="d-flex flex-column">
      <div
        className={
          ["xxl", "xl", "lg"].includes(screen)
            ? "scheduleFiltersRow w-100"
            : "scheduleFiltersRowMB w-100"
        }
      >
        {["xxl", "xl", "lg"].includes(screen) && (
          <>
            {userInfo?.fexRole !== "Faculty" ? (
              <div
                className={"d-flex flex-row align-items-center"}
                style={{ width: "280px" }}
              >
                <AutoSearchInput
                  setInputValue={(val: string) => handleSetInputValue(val)}
                  setSuggestions={setSuggestions}
                  suggestions={suggestions}
                  isLoader={isLoader}
                  setIsLoader={setIsLoader}
                  searchData={searchDataHandler}
                  searchName={searchName}
                  setSearchName={setSearchName}
                  placeholder="Search by faculty email"
                  nextHandler={nextHandler}
                  hasMore={hasMore}
                  mode={"faculty_search"}
                  onClickHandler={onClickHandler}
                  input={input}
                  setInput={setInput}
                />
                {selectedFaculty != null ? (
                  <div
                    onClick={() => {
                      handleResetSearchfaculty();
                    }}
                    className="d-flex justify-content-center align-items-center cursor-pointer pl-2"
                  >
                    <span
                      className={
                        selectedFaculty != null
                          ? "filterspanWidth"
                          : "filterSpan filterSpanFaculty"
                      }
                    >
                      Reset{" "}
                    </span>
                  </div>
                ) : null}
              </div>
            ) : null}
            <div className="d-flex align-items-center">
              <input
                className="form-check-input filterCheckbox mr-2"
                type="checkbox"
                checked={isNotmarkedVisible}
                onChange={NotMarkedChangeHandler}
              />
              <div className="d-flex">
                <ScheduleStatus status={"Unmarked"}></ScheduleStatus>
                <span>{totalUnmarkedLecture}</span>
                <InfoIcon id={"Tooltip-attendance"}></InfoIcon>
                <Tooltip
                  placement={"top"}
                  isOpen={tooltipOpen}
                  target={"Tooltip-attendance"}
                  toggle={toggle}
                >
                  {"Total unmarked lectures till yesterday"}
                </Tooltip>
              </div>
            </div>
          </>
        )}
        <div
          className={
            ["xxl", "xl", "lg"].includes(screen)
              ? "inputFilter"
              : "inputFilterMobileView"
          }
        >
          <ScheduleFilter
            dateRanges={dateRanges}
            setDateRanges={setDateRanges}
            setMin={setMin}
            setMax={setMax}
            min={min}
            max={max}
            room={room}
            syllabusStatus={syllabusStatus}
            classes={classes}
            subjects={subjects}
            startDate={startDate}
            endDate={endDate}
            isNotMarkedVisible={isNotmarkedVisible}
            isChecked={isChecked}
            setIsChecked={setIsChecked}
            filterState={filterState}
            handleFilter={handleFilter}
            setFilterState={setFilterState}
            setFilterData={setFilterState}
            isNotmarkedVisible={isNotmarkedVisible}
            open={open}
            setOpen={setOpen}
            setSelectedDateRange={setSelectedDateRange}
            isPaneOpen={isPaneOpen}
            setisPaneOpen={setisPaneOpen}
            NotMarkedChangeHandler={NotMarkedChangeHandler}
          ></ScheduleFilter>
        </div>
      </div>
      {!["xxl", "xl", "lg"].includes(screen) && (
        <>
          {userInfo?.fexRole !== "Faculty" ? (
            <div className="d-flex flex-row mt-2 p-3">
              <AutoSearchInput
                setInputValue={(val: string) => handleSetInputValue(val)}
                setSuggestions={setSuggestions}
                suggestions={suggestions}
                isLoader={isLoader}
                setIsLoader={setIsLoader}
                searchData={searchDataHandler}
                searchName={searchName}
                setSearchName={setSearchName}
                placeholder="Search by faculty email"
                nextHandler={nextHandler}
                hasMore={hasMore}
                mode={"faculty_search"}
                onClickHandler={onClickHandler}
                input={input}
                setInput={setInput}
                style={{ width: "100px" }}
              />
              {selectedFaculty != null ? (
                <div
                  onClick={() => {
                    handleResetSearchfaculty();
                  }}
                  className="d-flex justify-content-center align-items-center cursor-pointer pl-2"
                >
                  <span className={"crossBtn"}>X </span>
                </div>
              ) : null}
            </div>
          ) : null}
        </>
      )}
    </div>
  );
};
export default ScheduleTableFilter;
